import AsyncButton from "@/components/AsyncButton";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { FileCheckIcon, SignatureIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useToken } from "../hooks/useToken";
import { ContestAgreementsService } from "@/services/contestAgreements";
import { useState } from "react";

interface ContestAgreementsSignButtonProps {
  className?: string;
  disabled?: boolean;
}

export const ContestAgreementsSignButton = ({
  className,
  disabled,
}: ContestAgreementsSignButtonProps) => {
  const { t } = useTranslation();
  const token = useToken();
  const [success, setSuccess] = useState(false);

  const mutationFn = () => ContestAgreementsService.confirm(token);

  const mutation = useMutationWithErrorHandling({
    errorTitle: t("contestAgreements.errors.signAgreement"),
    mutationFn,
    onSuccess: () => {
      setSuccess(true); // to prevent a click during reload
      window.location.reload();
    },
  });

  return (
    <AsyncButton
      icon={success ? <FileCheckIcon /> : <SignatureIcon />}
      label={
        success
          ? t("contestAgreements.signedAgreementButton")
          : t("contestAgreements.signAgreementButton")
      }
      loadingLabel={t("contestAgreements.signAgreementButtonPending")}
      loading={mutation.isPending}
      className={className}
      onClick={mutation.mutateAsync}
      disabled={disabled || success}
    />
  );
};
